import axios from 'axios';

const baseURL = `${process.env.REACT_APP_API_URL}`;

export const tagAPI = {
  add: async (info) => axios.post(`${baseURL}/tags`, info).then((res) => res.data),
  all: async () => axios.get(`${baseURL}/tags`).then((res) => res.data),
  single: async (idToSearch) => axios.get(`${baseURL}/tags/${idToSearch}`).then((res) => res.data),
  update: async (idToSearch) => {
    const { id, ...details } = idToSearch;
    return axios.put(`${baseURL}/tags/${id}`, details).then((res) => res.data);
  },
  delete: async (idToSearch) => axios.delete(`${baseURL}/tags/${idToSearch}`).then((res) => res.data)
};
